module.exports = __webpack_public_path__ + "img/billing_income_report.2bc2aba6.svg";